import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../context/UserContext";
import FetchData from "../../../Helper/HttpRequestHelper";
import { buildUrlAuth } from "../../../Helper/UrlHelper";
import { Link } from "react-router-dom";
// import ThemeContext from "../../../context/ThemeContext";
import { Modal } from "react-bootstrap";
// import { Spinner } from "react-bootstrap";

const Dashboard = () => {
  const [networks, setNetworks] = useState([]);
  const { user } = useContext(UserContext);
  // const [loading, setLoading] = useState(false);
  const [eventRedirect, setEventRedirect] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  // const { setAlert } = useContext(ThemeContext);

  useEffect(() => {
    getDataNetworks();
    setEventRedirect(sessionStorage.getItem("event_redirect"));
  }, []);

  useEffect(() => {
    checkSplash();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventRedirect]);

  const getDataNetworks = () => {
    // setLoading(true)
    FetchData("networks")
      .then(
        (res) => {
          setNetworks(res.data);
        },
        (err) => {
          console.log("terjadi kesalahan.", err);
        }
      )
      .finally(() => {
        sessionStorage.removeItem("event_redirect");
      });
  };

  const checkSplash = () => {
    // return Object.keys(user.products).some((key) => key === "astradigital");
    setTimeout(() => {
      const open =
        eventRedirect === "check_splash" && !user.product_astra_digital;
      setOpenAlert(open);
    }, 500);
  };

  const setNetworkUrl = (network) => {
    const url = network.url;
    if (network.auth) {
      return buildUrlAuth(url);
    }
    return url;
  };

  const AlertModal = () => {
    return (
      <Modal
        show={openAlert}
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="d-grid gap-3 text-center my-3">
          <svg width="60" height="50" className="mb-1 mx-auto">
            <polygon points="30,0 0,45 60,45" fill="#F7DC6F" />
            <text
              x="30"
              y="30"
              fill="black"
              fontSize="30"
              fontWeight="bold"
              textAnchor="middle"
              dominantBaseline="middle"
            >
              !
            </text>
          </svg>
          <div className="mb-2 text-danger text-lg">
            It look like you don't have a SPLASH account daftar account yet,
            Call us to get a trial access.
          </div>
          <div className="d-flex justify-content-center gap-2">
            <button
              className="btn btn-light bg-white border-dark"
              onClick={() => {
                setOpenAlert(false);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                window.location.href =
                  process.env.REACT_APP_SPLASH_URL + "?contact=true";
              }}
            >
              Contact Us
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <>
      <div className="d-flex">
        <h3 className="mb-1">Hallo, {user.name}</h3>
      </div>
      <hr style={{ borderColor: "#dedede", borderWidth: "2px" }} />
      <div className="mt-4">
        <h5 style={{ color: "#404040" }}>Katadata Networks :</h5>
        <div className="row mt-3">
          {networks.map((network, index) => (
            <div key={index} className="col-6 col-md-6 col-lg-4 mb-3">
              <Link
                to={setNetworkUrl(network)}
                className="d-block"
                target="_blank"
              >
                <div className="card">
                  <div className="card-body bg-light network text-center">
                    <img
                      src={network.image}
                      alt=""
                      className="w-75 network-img"
                    />
                    <p className="network-description">{network.description}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
          {!!user.product_astra_digital && (
            <div className="col-6 col-md-6 col-lg-4">
              <Link
                to={process.env.REACT_APP_SPLASH_URL + "/dashboard"}
                className="d-block"
                target="_blank"
              >
                <div className="card">
                  <div className="card-body bg-light network text-center">
                    <img
                      src={`https://cdn1.katadata.co.id/template/template_splash/splash-logo-2024.png`}
                      alt=""
                      className="w-75 network-img"
                    />
                    <p className="network-description">{`Sales Planning and Synergy Hub Tools`}</p>
                  </div>
                </div>
              </Link>
            </div>
          )}
        </div>
      </div>
      <AlertModal />
    </>
  );
};

export default Dashboard;
